document.documentElement.classList.remove('no-js');

const waitlist = document.querySelector('[data-prelude-waitlist]');
const gallery = document.querySelector('[data-prelude-gallery]');
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const finePointer = window.matchMedia('(pointer: fine)');

if (waitlist && gallery && !reducedMotion.matches && finePointer.matches) {
  let animationFrame = null;

  const moveGallery = (event) => {
    if (animationFrame) window.cancelAnimationFrame(animationFrame);

    animationFrame = window.requestAnimationFrame(() => {
      const x = ((event.clientX / window.innerWidth) - 0.5) * -14;
      const y = ((event.clientY / window.innerHeight) - 0.5) * -10;
      gallery.style.setProperty('--gallery-x', `${x.toFixed(2)}px`);
      gallery.style.setProperty('--gallery-y', `${y.toFixed(2)}px`);
    });
  };

  waitlist.addEventListener('pointermove', moveGallery);
  waitlist.addEventListener('pointerleave', () => {
    gallery.style.setProperty('--gallery-x', '0px');
    gallery.style.setProperty('--gallery-y', '0px');
  });
}

document.querySelector('[data-waitlist-success]')?.focus();
